import React, {useContext} from 'react';
import "./QuestionAnswers.scss";
import { TwitterButton } from '../Buttons/Buttons';
const btnStyles = {
  padding: "10px",
  color: "#ffffff",
  backgroundColor: "#00acee"
};
const Confirmation = () => {
 

  return (
    
    <React.Fragment>
        <div>
            <h1>Thank you for warming up with us.</h1>
            <p>You have completed the Weed Identification Quiz and earned one ballot in the Feel the Burn Contest. Tell us how well you did on Twitter by tweeting us with the button below.</p>
            <a
            data_tealium_category="link"
            data_tealium_action="click"
            data_tealium_type="click social-link"
            data_tealium_value="Twitter|https://twitter.com/basfagsolutions"
            href="https://ctt.ac/G6HTv"
            target="_blank"
            rel="noopener noreferrer"
            title="Tell us on Twitter"
            style={btnStyles}
          >
            <b>Tell us @BASFAgSolutions </b>
          </a>
        </div>
    </React.Fragment>
   
  );
};

export default Confirmation;